import React from 'react';
import PropTypes from 'prop-types';

// styles
import css from './layout.sss';


const LayoutHeader = (props) => {
    return (
        <div className={css.header}>
            {props.children}
        </div>
    );
};

const LayoutBody = (props) => {
    return (
        <div className={css.body}>
            {props.children}
        </div>
    );
};

export const Layout = (props) => {
    return (
        <div className={css.root} data-qaid={props.dataQa}>
            {props.children}
        </div>
    );
};

Layout.propTypes = {
    dataQa: PropTypes.string,
};

Layout.Header = LayoutHeader;
Layout.Body = LayoutBody;
